import App from './App.vue';
import './assets/main.scss'
import {Config} from 'vueform'
import {ResponsiveAppMount} from 'lvm-responsive-app-mount';
import type {FormConfigs} from '@/interfaces/FormConfigs.inteface';

const configuration: FormConfigs = Joomla.getOptions('configuration');
const renderInPopup: boolean = configuration.renderInPopup;
const moduleSelector: string = configuration.moduleSelector;

new ResponsiveAppMount('lvm-land-purchase', moduleSelector, renderInPopup, App, Config).init();
